import React, {Component} from 'react';
import {connect} from 'react-redux';
import {redirectToValidationAccessCode} from '../../ducks/Navigate';
import {ScreenNotificationDefault, Footer} from '../../components';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class PreEvaluationCompletedFail extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.PreEvaluationCompletedFail.title,
    );
  }

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Análise Concluída</p>}
        contentCustom={
          <div className="div-pre-evaluation-completed-fail">
            <div>&nbsp;</div>
            <div className="info justify">
              <i>
                Agradecemos seu interesse pelo cartão, mas nesse momento não foi
                possível atendê-lo.
              </i>
            </div>
            <div>&nbsp;</div>
          </div>
        }
        contentButtons={
          <div className="div-data-contact">
            <Footer nextForm="frm" hideBtnBack={true} hideBtnNext={true} />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {redirectToValidationAccessCode})(
  PreEvaluationCompletedFail,
);
